import React, { useRef, useState } from "react";
import { PageLayout } from "../../components/PageLayout";
import { navigate, Router } from "@reach/router";
import { NoParam } from "./NoParam";
import { GistParam } from "./GistParam";
import { GistStateProvider } from "./context";

import { reducer, initialState } from "./reducer";

export const Gist = () => {
  return (
    <GistStateProvider reducer={reducer} initialState={initialState}>
      <Router>
        <NoParam path="/" />
        <GistParam path=":gistId" />
      </Router>
    </GistStateProvider>
  );
};
